<template>
  <div>
    <div v-if="isExistSearchResult">
      <table id="data-table" class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">拠点コード</th>
            <th scope="col">拠点名称</th>
            <th scope="col">作成日時</th>
            <th scope="col">更新日時</th>
            <th scope="col">棚卸識別名</th>
            <th scope="col">帳簿数</th>
            <th scope="col">棚卸数</th>
            <th scope="col">棚卸状態</th>
            <th scope="col">削除</th>
            <th scope="col">承認</th>
            <th scope="col">解除</th>
            <th scope="col">棚卸<br>結果DL</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, index) in inventoryInfoList" :key="value.inventoryCode">
            <td scope="row" class="table-cell-wrap mw170 mxw170">{{ value.sectionCode }}</td>
            <td scope="row" class="table-cell-wrap mw130 mxw130">{{ value.sectionName }}</td>
            <td class="table-cell-wrap mw120 mxw120">{{ value.createDateTime }}</td>
            <td class="table-cell-wrap mw120 mxw120">{{ value.updateDateTime }}</td>
            <td class="table-cell-wrap mw130 mxw130">{{ value.inventoryName }}</td>
            <td class="table-cell-wrap mw70 mxw70">{{ value.stockTotal }}</td>
            <td class="table-cell-wrap mw70 mxw70">{{ value.inventoryQuantity }}</td>
            <td class="table-cell-wrap mw100 mxw100">{{ getInventoryStatus(value.inventoryStatus) }}</td>
            <td class="table-cell-wrap mw70 mxw70">
              <button type="button" class="deleteBtn" v-show="displayDelete(value.inventoryStatus)" @click="clickDelete(value, index)">削除</button>
            </td>
            <td class="table-cell-wrap mw70 mxw70">
              <button type="button" class="approvalBtn" v-show="displayApproval(value.inventoryStatus)" @click="clickApproval(value)">承認</button>
            </td>
            <td class="table-cell-wrap mw70 mxw70">
                <button type="button" class="releaseBtn" v-show="displayRelease(value)" @click="clickRelease(value)">解除</button>
            </td>
            <td class="table-cell-wrap mw70 mxw70">
              <div v-show="displayDL(value.inventoryStatus)">
                <a href="#" id="download" @click="clickDL(value)">DL</a>
                <div id="loading" style="display:none">
                  <p>DL</p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      検索結果は0件です。
    </div>
    <!-- 処理中アイコン -->
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<script>
import Loading from '@/components/atoms/Loading'

export default {
  name: 'inventory-search-result',
  props: {
    inventoryInfoList: {
      type: Array,
      default: null
    },
    isExistSearchResult: false
  },
  components: {
    Loading
  },

  data () {
    return {
      isLoading: false
    }
  },

  methods: {
    /**
     * 棚卸情報の表示文字列の取得
     */
    getInventoryStatus (inventoryStatus) {
      switch (inventoryStatus) {
        case 0:
          return '棚卸準備中'
        case 1:
          return '棚卸中'
        case 2:
          return '完了'
        case 3:
          return '承認済'
        default:
          return ''
      }
    },

    /**
     * 削除ボタンの表示制御
     */
    displayDelete (inventoryStatus) {
      return inventoryStatus === 3 && this.$session.get('inventoryDeleteDiv') === 0 && this.$session.get('userDiv') === 1
    },

    /**
     * 承認ボタンの表示制御
     */
    displayApproval (inventoryStatus) {
      return inventoryStatus === 2 && this.$session.get('userDiv') === 1
    },

    /**
     * 解除ボタンの表示制御
     */
    displayRelease (item) {
      var unlockPermissionFlg = false
      if (item.inventoryStatus === 3) {
        unlockPermissionFlg = true
        for (var value in this.inventoryInfoList) {
          if (item.inventoryCode !== value.inventoryCode) {
            if (item.sectionCode === value.sectionCode && value.inventoryStatus !== 3) {
              // 同一拠点かつ承認済み以外のデータが存在する場合
              unlockPermissionFlg = false
            }
          }
        }
      }
      this.$set(item, 'unlockPermissionFlg', unlockPermissionFlg)
      return item.inventoryStatus === 3 && this.$session.get('inventoryCancelDiv') === 0 && unlockPermissionFlg && this.$session.get('inventoryCompletionDiv') === 0
    },

    /**
     * DLボタンの表示制御
     */
    displayDL (inventoryStatus) {
      return inventoryStatus === 3 && (this.$session.get('userDiv') === 1 || this.$session.get('inventoryDownloadDiv') === 0)
    },

    /**
     * 削除ボタン押下処理
     */
    async clickDelete (value, index) {
      if (confirm('棚卸を削除してもよろしいですか？')) {
        // 削除処理：棚卸情報操作（削除）API
        await this.axios.post('/api/inventory/delete', {
          'inventoryCode': value.inventoryCode,
          'sectionCode': value.sectionCode
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        }).then((response) => {
          alert('削除が完了しました。')
          location.reload()
        })
      }
    },

    /**
     * 承認ボタン押下処理
     */
    async clickApproval (value) {
      if (confirm('承認してもよろしいですか？')) {
        // 承認処理：棚卸情報操作（更新）API
        await this.axios.post('/api/inventory/update', {
          'inventoryCode': value.inventoryCode,
          'sectionCode': value.sectionCode,
          'inventoryStatus': 3,
          'deviceDiv': 1
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        }).then((response) => {
          alert('承認が完了しました。')
          location.reload()
        })
      }
    },

    /**
     * 解除ボタン押下処理
     */
    async clickRelease (value) {
      if (confirm('解除してもよろしいですか？')) {
        // 承認処理：棚卸情報操作（更新）API
        await this.axios.post('/api/inventory/update', {
          'inventoryCode': value.inventoryCode,
          'sectionCode': value.sectionCode,
          'inventoryStatus': 1,
          'deviceDiv': 1
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        }).then((response) => {
          alert('解除が完了しました。')
          // this.inventoryInfoList.splice(index, 1)
          location.reload()
        })
      }
    },

    /**
     * DLリンク押下処理
     */
    async clickDL (value) {
      try {
        // 処理中アイコン表示
        this.isLoading = true
        // 棚卸情報DL処理：棚卸結果ダウンロードAPI
        await this.axios.post('/api/inventory/result/download', {
          'inventoryCode': value.inventoryCode,
          'sectionCode': value.sectionCode,
          'inventoryDownloadDiv': this.$session.get('inventoryDownloadDiv')
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          },
          responseType: 'blob'
        }).then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          // APIからファイル名を取得できなかった場合を想定し、初期値にファイル名を設定しておく
          var filename = 'InventoryResults.zip'
          var disposition = response.headers['content-disposition']
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }

          // IEとそれ以外でダウンロード処理を切り分ける
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(new Blob([response.data]), filename)
          } else {
            // それ以外
            link.download = filename
            link.href = url
            document.body.appendChild(link)
            link.click()
          }
        })
      } catch (ex) {
        throw ex
      } finally {
        // 処理中アイコン非表示
        this.isLoading = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/InventoryInfoSearchResult.vue